export default __webpack_public_path__ + "static/74835-073cb802958776e599ce8016a8454aa2.jpg";